//配置全局访问接口地址
// 本地
// let commonUrl = "http://localhost:8080/#/";
// 服务器
let commonUrl = "http://www.tianyuzl.com/#/";

let baseUrl = {
    commonUrl
}
export default baseUrl